export const productFragment = /* GraphQL */ `
  fragment productStatus on ProductStatusDTO {
    action
    batchedProductID
    brand
    byUserID
    category
    channels
    co2Impact
    color
    complement
    complementEN
    complementNL
    condition
    createdAt
    description
    descriptionEN
    descriptionNL
    dimension {
      diameter
      height
      length
      unit
      width
    }
    eliminationIndex
    endDate
    id
    internalNotes
    instructions
    availableForSale
    isInsured
    isPromoted
    linkFdes
    linkTechnicalSheet
    lot
    material
    model
    name
    nature
    provenance
    pictures
    placeID
    location {
      lat
      lon
    }
    price {
      amount
      currency
      discountAmount
      discountRatio
    }
    proofPictures
    productID
    projectID
    progress
    quantity {
      number
      unit
    }
    recyclabilityIndex
    referenceID
    ref
    reemploymentIndex
    removalIndex
    reusabilityIndex
    spot
    startDate
    toPlaceID
    type
    typology
    updatedAt
    updatedBy
    valorisationIndex
    valueIndex
    wasteCost
    weight
    organizationID
    shopID
    slug
    dimensionRange {
      key
      min
      max
    }
    internalNotes
    instructionAssembly
    instructionRemoval
    instructionTransport
    instructionStorage
    instructionConditioning
    instructionPotential
    instructionSafety
    properties {
      key
      values
      type
    }
    externalUrl
    externalSource
    shapeID
    sortIndex
  }
`
export const productFragmentNormal = /* GraphQL */ `
  fragment productStatus on ProductStatus {
    accountMaintenance {
      cycleID
      at
      reason
      previousType
      previousAction
      previousProgress
      previousUpdatedAt
      previousAvailableForSale
    }
    action
    batchedProductID
    brand
    byUserID
    category
    channels
    co2Impact
    color
    complement
    complementEN
    complementNL
    condition
    createdAt
    description
    descriptionEN
    descriptionNL
    dimension {
      diameter
      height
      length
      unit
      width
    }
    eliminationIndex
    endDate
    id
    internalNotes
    instructions
    availableForSale
    isInsured
    isPromoted
    linkFdes
    linkTechnicalSheet
    lot
    material
    model
    name
    nature
    organizationID
    provenance
    pictures
    placeID
    location {
      lat
      lon
    }
    price {
      amount
      currency
      discountAmount
      discountRatio
    }
    proofPictures
    productID
    projectID
    progress
    quantity {
      number
      unit
    }
    recyclabilityIndex
    referenceID
    ref
    reemploymentIndex
    removalIndex
    reusabilityIndex
    spot
    startDate
    toPlaceID
    type
    typology
    updatedAt
    updatedBy
    valorisationIndex
    valueIndex
    wasteCost
    weight
    organizationID
    shopID
    slug
    dimensionRange {
      key
      min
      max
    }
    instructionAssembly
    instructionRemoval
    instructionTransport
    instructionStorage
    instructionConditioning
    instructionPotential
    instructionSafety
    properties {
      key
      values
      type
    }
    externalUrl
    externalSource
    shapeID
    sortIndex
  }
`
